import { NavigationMenuContext } from '@/components/_headers/_shared/navigationMenuContext'
import { cn } from '@/lib/utils'
import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import React, { useContext, useEffect, useRef, useState } from 'react'

const NavigationMenuContent = React.forwardRef<
  React.ElementRef<typeof NavigationMenuPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Content>
>(({ className, ...props }, ref) => {
  const targetRef = useRef<HTMLDivElement | null>(null)

  const [isRendered, setIsRendered] = useState(false)
  const {
    isNavigationMenuOpen,
    setNavigationHeight,
    navigationMenuValue,
    navigationHeight,
  } = useContext(NavigationMenuContext)

  useEffect(() => {
    if (isNavigationMenuOpen) {
      setTimeout(() => {
        setIsRendered(true)
      }, 150)
    }

    return () => setIsRendered(false)
  }, [isNavigationMenuOpen])

  useEffect(() => {
    setTimeout(() => {
      if (
        targetRef.current &&
        targetRef.current.offsetHeight !== navigationHeight
      ) {
        setNavigationHeight(targetRef.current.offsetHeight)
      }
    }, 100)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigationMenuValue, targetRef])

  return (
    <NavigationMenuPrimitive.Content
      ref={ref}
      className={cn(
        'data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52  ',
        'absolute left-0 z-40 flex w-screen items-center justify-center', // Adjust these classes as per your needs      className,
        'bg-white',
      )}
      {...props}
    >
      <div
        className={
          isRendered
            ? 'transition duration-500 ease-in-out'
            : '-translate-y-5 opacity-0 transition duration-300 ease-in-out'
        }
      >
        <div ref={targetRef}>{props.children}</div>
      </div>
    </NavigationMenuPrimitive.Content>
  )
})

NavigationMenuContent.displayName = NavigationMenuPrimitive.Content.displayName

export default NavigationMenuContent
